import Link from 'components/gruenland/atoms/link';
import { Info } from 'components/gruenland/icons/Info';
import { Marker } from 'components/gruenland/icons/Marker';
import { Reference } from 'types/reference';

export type TopBarMenuItemProps = {
  label: string;
  icon: 'FiMapPin' | 'FiInfo';
  link: Reference;
};

export const TopBarMenuItem: React.FC<TopBarMenuItemProps> = ({ label, icon, link }) => {
  return (
    <Link link={link} className="flex items-center gap-3 text-[14px]/[17.64px] font-medium tracking-[.02em] text-white">
      {label} {icon === 'FiInfo' ? <Info width={22} height={22} /> : <Marker width={22} height={22} />}
    </Link>
  );
};
